import React, { Component } from 'react';
import { Button, Table, FormControl, Row, Col, Checkbox, Glyphicon } from 'react-bootstrap'
import Api from '../../../../Global/Modules/Api'
import ButtonsAdminToevoegen from '../Lid/AddButtonsadmin'

class PermanenteKennis extends Component {
    constructor() {
        super();
        this.handleDelete = this.handleDelete.bind(this)
        this.handleCB = this.handleCB.bind(this)
        this.handlePaginationClick = this.handlePaginationClick.bind(this)
        this.handleKnownKennisClick = this.handleKnownKennisClick.bind(this)
        this.handleChangePageSize = this.handleChangePageSize.bind(this)
        this.handleClickClass = this.handleClickClass.bind(this)
        this.handleUnknownChange = this.handleUnknownChange.bind(this)
        this.getKennis = this.getKennis.bind(this)
        this.handleClickDoc = this.handleClickDoc.bind(this)
        this.state = {
            kennis: [],
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0
            },
            currentFetchUrl: '', // To know where to fetch (to refresh companies) if a company is deleted
        }
    }
    handleChangePageSize(e) {
        this.setState({ pagination: { ...this.state.pagination, pageSize: e.target.value } })
        this.getKennis("api/members/" + this.props.id + "/permanentknowneducation?PageSize=" + e.target.value)
    }
    handleClickClass() {
        if (this.state.tableclass == '') {
            this.setState({ tableclass: 'show-table-full-width' })
        } else {
            this.setState({ tableclass: '' })
        }
    }
    componentWillMount() {
        const FETCH_URL = "api/members/" + this.props.id + "/permanentknowneducation"
        this.setState({ currentFetchUrl: FETCH_URL })
        this.getKennis(FETCH_URL)
    }
    handleCB(event, id) {
        let name = event.name
        this.setState({
            [event.value]: event.checked ? "checked" : ""
        })
        this.setState({ [name]: { ...this.state[name], [id]: event.checked ? true : false } })
    }
    handleKnownKennisClick(e) {
        e.preventDefault()
        var list = []
        for (var key in this.state.CB) {
            list.push(key + ";" + this.state.CB[key]);
        }
        for (var key in this.state.knownPoints) {
            list.push(key + ";" + this.state.knownPoints[key]);
        }
        Api.PostApi("api/members/" + this.props.id + "/updatepoints", list.join(), this.props.history)
            .then(response => {
                if (response !== undefined) {
                    this.setState({ errors: response });
                }
                else {
                    alert("Points updated")
                    window.location.reload();
                    // TODO: Show message OK
                }
            })
    }
    handleUnknownChange(value, name, id, type) {
        this.setState({ [name]: { ...this.state[name], [id]: value + "#" + type } })
    }
    handleDelete = (type, id) => event => {
        event.preventDefault()
        if (window.confirm('Are you sure you wish to delete this item?')) {
            const FETCH_URL_DELETE = `api/educations/${type}/${id}/${this.props.id}`
            Api.DeleteApi(FETCH_URL_DELETE).then(response => {
                Api.print(`Response delete ${id}`)
                Api.print(response)
                this.getKennis(this.state.currentFetchUrl) // Update the educations list
            })
        }

        else Api.print('Think it better.')

    }
    handleClickDoc(e, t) {
        var url = "api/members/" + e + "/" + t + "/getDiploma";
        Api.GetApiDownload(url)
    }
    handlePaginationClick(e) {
        const FETCH_URL3 = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.setState({ currentFetchUrl: FETCH_URL3 })
        this.getKennis(FETCH_URL3)
    }
    getKennis(fetchUrl) {
        Api.GetTableApi(fetchUrl, this.handlePaginationClick).then(response => {

            this.setState({ pagination: response.pagination }) // Pagination object 
            return response.data.json() // Data -> companies object
        }).then(objectData => {
            if (objectData !== undefined) {
                objectData.map((comp) => this.setState({ ['cb' + comp.id]: (comp.educationType == 0 && comp.approved ? "checked" : "") }))
                this.setState({ kennis: objectData });
            }
            // Companies object
        })
    }
    render() {
        let kennis = this.state.kennis
        return (
            <div>
                <ButtonsAdminToevoegen id={this.props.id} />
                <div className="permanenteEducatieBekend">
                    <h5><strong>Permanente educatie bekend</strong></h5>
                    <Button onClick={this.handleClickClass}>Toon volledige tabel</Button>
                    <Row>
                        <Col md={1} sm={1}>
                            <FormControl name='pageSize' componentClass="select" placeholder="select" onChange={this.handleChangePageSize} value={this.state.pagination.pageSize}>
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="0">All</option>
                            </FormControl>
                        </Col>
                    </Row>
                    <div>Resultaten  {(this.state.pagination.pageSize == '0' || this.state.pagination.pageSize > this.state.pagination.totalCount) ? this.state.pagination.totalCount : this.state.pagination.pageSize} van {this.state.pagination.totalCount}</div>
                    <div className={"table-responsive " + this.state.tableclass}>
                        <Table striped bordered hover className="text-center">
                            <thead>
                                <tr>
                                    <th>invoerstatus</th>
                                    <th>type</th>
                                    <th>niveau</th>
                                    <th>instelling</th>
                                    <th>opleiding / publicatie</th>
                                    <th>plaats</th>
                                    <th>diploma / publicatie</th>
                                    <th>jaar van</th>
                                    <th>afronding in</th>
                                    <th>diploma</th>
                                    <th>type educatie</th>
                                    <th>akkoord</th>
                                    <th>punten</th>
                                    <th>punten aanpassen</th>
                                    <th>verwijder</th>
                                </tr>
                            </thead>
                            <tbody>
                                {kennis !== undefined ? kennis.map((comp) => {
                                    return (<tr key={comp.id}>
                                        <td>{comp.memberType}</td>
                                        {/*
                                    0 = ASP
                                    1 = RC
                                    2 = RO
                                    3 = RTa
                                    4 = RTb
                                    */}
                                        <td>{comp.type}</td>
                                        <td>{comp.level}</td>
                                        <td>{comp.institution}</td>
                                        <td>{comp.name}</td>
                                        <td>{comp.city}</td>
                                        <td>{comp.diploma ? 'ja' : 'nee'}</td>
                                        <td>{comp.fromYear}</td>
                                        <td>{comp.finishYear}</td>
                                        <td>{comp.diplomaName !== '' && comp.diplomaName !== null && comp.diplomaName !== undefined ?
                                            <a onClick={() => this.handleClickDoc(comp.id, comp.educationType)} target="_blank">bekijk<br /></a>
                                            : ''}
                                            {/* <br /><a href="#">[EditFile]</a> */}
                                        </td>
                                        <td>{comp.ifTypeIsFiled}</td> {/*TypeBijeenkomst/TypeCursus/TypeInCompany/TypeVoordracht*/}
                                        <td>{comp.educationType == 0 ? comp.approved ? <Checkbox checked={this.state['cb' + comp.id]} name="CB" value={'cb' + comp.id} onChange={e => this.handleCB(e.target, comp.id)} /> : <Checkbox value={'cb' + comp.id} name="CB" onChange={e => this.handleCB(e.target, comp.id)} /> : ""}</td>
                                        <td>{comp.initialPoints}</td>
                                        <td><FormControl type="number" name="knownPoints" placeholder={comp.approved ? "" + comp.points : ""} type="number" onChange={e => this.handleUnknownChange(e.target.value, e.target.name, comp.id, comp.educationType)} /></td>
                                        <td><Button bsSize="xsmall" className="delete" onClick={this.handleDelete(comp.educationType, comp.id)}>
                                            <Glyphicon glyph="remove" />
                                        </Button></td>
                                    </tr >)
                                }) : ""}
                            </tbody>
                        </Table>
                    </div>
                    <div className="paginationStyling">
                        <div style={{ float: 'left' }}>
                            {this.state.pagination.prevButton}
                        </div>
                        <div style={{ float: 'center' }}>
                            Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                        </div>
                        <div style={{ float: 'right' }}>
                            {this.state.pagination.nextButton}
                        </div>
                    </div>
                    <Button type="button" onClick={this.handleKnownKennisClick}>Wijzigingen opslaan</Button>
                </div>
            </div>
        )
    }
}
export default PermanenteKennis;




// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/PermanenteKennis.js